var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "005---Sync-ANF---Select-Target-Volume",
    transform: "translate(-538.000000, -393.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Table",
    transform: "translate(318.000000, 343.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "table-header"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-sort-",
    transform: "translate(220.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle",
    fillRule: "nonzero",
    transform: "translate(3.500000, 10.333333) rotate(180.000000) translate(-3.500000, -10.333333) ",
    points: "3.5 7.9999993 7 12.666666 4.4408921e-16 12.666666"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle-Copy",
    fillRule: "nonzero",
    points: "12.5 0 16 4.66666667 9 4.66666667"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillRule: "nonzero",
    x: 3,
    y: 0,
    width: 1,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fillRule: "nonzero",
    transform: "translate(12.500000, 8.500000) rotate(180.000000) translate(-12.500000, -8.500000) ",
    x: 12,
    y: 4,
    width: 1,
    height: 9
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.df89d5df1e08458d47405929d678b596.svg";
export { ForwardRef as ReactComponent };